import {
    Component,
    OnInit,
    AfterViewInit,
    AfterViewChecked,
    AfterContentInit
} from '@angular/core';
import {
    AuthService
} from '../authentication/authService';

declare var $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    rights: string;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
    rights: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
    path: '/front',
    title: 'Voorkant',
    type: 'sub',
    icontype: 'pe-7s-back-2',
    rights: 'Admin, Mangel, Logistic',
    children: [{
        path: 'mangel1',
        title: 'Mangel 1 Voor',
        ab: '1',
        rights: 'Admin, Mangel, Logistic'
    },
        {
            path: 'mangel2',
            title: 'Mangel 2 Voor',
            ab: '2',
            rights: 'Admin, Mangel, Logistic'
        },
        {
            path: 'mangel3',
            title: 'Mangel 3 Voor',
            ab: '3',
            rights: 'Admin, Mangel, Logistic'
        }
    ]
},
    {
        path: '/back',
        title: 'Achterkant',
        type: 'sub',
        icontype: 'pe-7s-next-2',
        rights: 'Admin, Mangel, Logistic',
        children: [{
            path: 'mangel1',
            title: 'Mangel 1 Achter',
            ab: '1',
            rights: 'Admin, Mangel, Logistic'
        },
            {
                path: 'mangel2',
                title: 'Mangel 2 Achter',
                ab: '2',
                rights: 'Admin, Mangel, Logistic'
            },
            {
                path: 'mangel3',
                title: 'Mangel 3 Achter',
                ab: '3',
                rights: 'Admin, Mangel, Logistic'
            },
            {
                path: 'badstofvouwer',
                title: 'Badstofvouwer',
                ab: '4',
                rights: 'Admin, Mangel, Logistic'
            },
            {
                path: 'mangel4',
                title: 'Kleine wasmachine',
                ab: '5',
                rights: 'Admin, Mangel, Logistic'
            },
        ]
    }, {
        path: '/customer',
        title: 'Klantgegevens',
        type: 'sub',
        icontype: 'pe-7s-users',
        rights: 'Admin, Logistic',
        children: [{
            path: 'overview',
            title: 'Klanten overzicht',
            ab: '1',
            rights: 'Admin, Logistic'
        }, {
            path: 'leads',
            title: 'Lead overzicht',
            ab: '1',
            rights: 'Admin, Logistic'
        }, {
            path: 'add',
            title: 'Klant toevoegen',
            ab: '2',
            rights: 'Admin, Logistic'
        },
            {
                path: 'update',
                title: 'Klant wijzigen',
                ab: '3',
                rights: 'Admin, Logistic'
            },
        ]
    }, {
        path: '/prices',
        title: 'Prijzen',
        type: 'sub',
        icontype: 'pe-7s-ticket',
        rights: 'Admin',
        children: [{
            path: 'mangelPrices',
            title: 'Mangel prijzen',
            ab: '1',
            rights: 'Admin'
        },
            {
                path: 'specialPrices',
                title: 'Speciale prijzen',
                ab: '2',
                rights: 'Admin'
            },
            {
                path: 'transportToeslag',
                title: 'Tol toeslag',
                ab: '6',
                rights: 'Admin'
            },
            {
                path: 'priceChanges',
                title: 'Prijzen wijzigen',
                ab: '3',
                rights: 'Admin'
            },
            {
                path: 'priceHistory',
                title: 'Prijs historie',
                ab: '4',
                rights: 'Admin'
            },
            {
                path: 'priceHistoryTotal',
                title: 'Prijs historie compleet',
                ab: '5',
                rights: 'Admin'
            }
        ]
    },
    {
        path: '/mangelAdmin',
        title: 'MangelAdmin',
        type: 'sub',
        icontype: 'pe-7s-key',
        rights: 'Admin, External, Logistic',
        children: [{
            path: 'admin',
            title: 'Mangel',
            ab: '1',
            rights: 'Admin, External, Logistic'
        },
            {
                path: 'customerAdmin',
                title: 'Handmatige pakbon',
                ab: '2',
                rights: 'Admin, Logistic'
            },
            {
                path: 'adminOverview',
                title: 'Mangel overzicht',
                ab: '3',
                rights: 'Admin, Logistic'
            }
        ]
    },
    {
        path: '/invoice',
        title: 'Facturatie',
        type: 'sub',
        icontype: 'pe-7s-cash',
        rights: 'Admin',
        children: [{
            path: 'manualInvoice',
            title: 'Handmatige factuur',
            ab: '1',
            rights: 'Admin'
        },
            {
                path: 'invoiceWizard',
                title: 'Facturatie run',
                ab: '2',
                rights: 'Admin'
            },
            {
                path: 'openInvoice',
                title: 'Open facturen',
                ab: '3',
                rights: 'Admin'
            },
            {
                path: 'closedInvoice',
                title: 'Gesloten facturen',
                ab: '4',
                rights: 'Admin'
            },

        ]
    },
    {
        path: '/pickOrder',
        title: 'Pakbonnen',
        type: 'sub',
        icontype: 'pe-7s-note2',
        rights: 'Admin, Logistic',
        children: [{
            path: 'orders',
            title: 'Pakbon overzicht',
            ab: '1',
            rights: 'Admin, Logistic'
        },
        {
            path: 'pakbonHistory',
            title: 'Pakbon historie overzicht',
            ab: '1',
            rights: 'Admin, Logistic'
        },
        {
            path: 'creditOrders',
            title: 'Retourbon overzicht',
            ab: '1',
            rights: 'Admin, Logistic'
        },
            {
                path: 'closedOrders',
                title: 'Zoek pakbonnen',
                ab: '1',
                rights: 'Admin, Logistic'
            },
            {
                path: 'pakbonControle',
                title: 'Pakbon controle',
                ab: '1',
                rights: 'Admin, Logistic'
            },
        ]
    },
    {
        path: '/routes',
        title: 'Routes',
        type: 'sub',
        icontype: 'pe-7s-way',
        rights: 'Admin, Driver',
        children: [{
            path: 'routesOverview',
            title: 'Route overzicht',
            ab: '1',
            rights: 'Admin'
        },
        {
            path: 'routes',
            title: 'Routes',
            ab: '1',
            rights: 'Admin, Driver'
        },
        {
            path: 'route-names',
            title: 'Route namen',
            ab: '1',
            rights: 'Admin'
        }]
    },
    {
        path: '/bank',
        title: 'Exact',
        type: 'link',
        icontype: 'pe-7s-global',
        rights: 'Admin'
    },
    {
        path: '/history',
        title: 'Historie',
        type: 'sub',
        icontype: 'pe-7s-date',
        rights: 'Admin, Logistic',
        children: [{
            path: 'packingslips',
            title: 'Pakbon historie',
            ab: '1',
            rights: 'Admin, Logistic'
        },
        {
            path: 'creditOrders',
            title: 'Retourbon historie',
            ab: '1',
            rights: 'Admin, Logistic'
        }]
    },
    {
        path: '/users',
        title: 'Gebruikers',
        type: 'link',
        icontype: 'pe-7s-user',
        rights: 'Admin'
    }
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent {
    public menuItems: any[];

    constructor(private authService: AuthService) {

    }

    isNotMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }

    ngOnInit() {
        var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
        this.menuItems = ROUTES.filter(menuItem => menuItem);

        isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            $('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();
            $('html').addClass('perfect-scrollbar-on');
        } else {
            $('html').addClass('perfect-scrollbar-off');
        }
    }

    doLogout() {
        this.authService.logout();
    }

    private normalizeRole(role: string): string {
        const normalizedRole = role.trim().toLowerCase();
        return normalizedRole === 'extern' ? 'external' : normalizedRole;
    }

    hasRights(menuItem) {
        if (!menuItem || !menuItem.rights) {
            return false;
        }
        
        if (menuItem.rights === '') {
            return true;
        }
        
        const userRole = this.authService.getRoles();
        if (!userRole) {
            return false;
        }
        
        const allowedRoles = menuItem.rights.split(',').map(role => this.normalizeRole(role));
        const userRoleLower = this.normalizeRole(userRole);
        
        return allowedRoles.includes(userRoleLower);
    }

    ngAfterViewInit() {
        var $sidebarParent = $('.sidebar .nav > li.active .collapse li.active > a').parent().parent().parent();

        var collapseId = $sidebarParent.siblings('a').attr("href");

        $(collapseId).collapse("show");
    }
}